import { AfterViewChecked, Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { navigation } from '../../../../../data/header-navigation';
import { NavigationLink } from '@interfaces/navigation-link';
import { DirectionService } from '@services/direction.service';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HeaderService } from '@services/header.service';
import { TranslateService } from '@ngx-translate/core';
import { HomepageService } from '@app/_services/homepage.service';
import { SharedService } from '@app/_services/shared.service';
import * as _ from 'lodash';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { MenuComponent } from '../menu/menu.component';
import { TouchClickDirective } from '../../../../shared/directives/touch-click.directive';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { OutsideTouchClickDirective } from '../../../../shared/directives/outside-touch-click.directive';
import { NgIf, NgFor, NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-header-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass, OutsideTouchClickDirective, IconComponent, RouterLink, TouchClickDirective, NgTemplateOutlet, MenuComponent, MegamenuComponent]
})
export class LinksComponent implements OnInit, OnDestroy, AfterViewChecked {
    @ViewChildren('submenuElement') submenuElements: QueryList<ElementRef>;
    @ViewChildren('itemElement') itemElements: QueryList<ElementRef>;

    destroy$: Subject<void> = new Subject<void>();

    items: NavigationLink[] = [];
    hoveredItem: NavigationLink = null;
    sectores = [];
    reCalcSubmenuPosition = false;

    stores='';
    becomeVendor='';

    currentPage;
    constructor(
        private sharedService: SharedService,
        private homepageService: HomepageService,
        private direction: DirectionService,
        private header: HeaderService,
        private zone: NgZone,
        private translate: TranslateService,
        private cd: ChangeDetectorRef,

    ) {
        this.translate.get('stores').subscribe((res: string) => {
            this.stores = res;
            this.items.push({label: this.stores, url: '/site/stores'},);
        });
        this.translate.get('blog').subscribe((res: string) => {
            this.items.push({label: res, url: '/blog'});
        });
        this.translate.get('become_vendor').subscribe((res: string) => {
            this.becomeVendor = res;
            this.items.push({label: this.becomeVendor, url: '/apply-for-vendor'});
        });

    }

    onItemMouseEnter(item: NavigationLink): void {
        if (this.hoveredItem !== item) {
            this.hoveredItem = item;

            if (item.menu) {
                this.reCalcSubmenuPosition = true;
            }
        }
    }

    onItemMouseLeave(item: NavigationLink): void {
        if (this.hoveredItem === item) {
            this.hoveredItem = null;
        }
    }

    onTouchClick(event, item: NavigationLink): void {
        if (event.cancelable) {
            if (this.hoveredItem && this.hoveredItem === item) {
                return;
            }

            if (item.menu) {
                event.preventDefault();

                this.hoveredItem = item;
                this.reCalcSubmenuPosition = true;
            }
        }
    }

    onOutsideTouchClick(item: NavigationLink): void {
        if (this.hoveredItem === item) {
            this.zone.run(() => this.hoveredItem = null);
        }
    }

    onSubItemClick(): void {
        this.hoveredItem = null;
    }

    ngOnInit(): void {
        merge(
            this.header.navPanelPositionState$,
            this.header.navPanelVisibility$,
        ).pipe(takeUntil(this.destroy$)).subscribe(() => this.hoveredItem = null);

        this.sharedService.page$.subscribe(page => {
            if(page) {
               this.currentPage = page;
               let _navigation = _.cloneDeep(navigation);
               /* if (page != "homepage") {
                   _navigation[0] = {label: 'Categories', url: ''};
               } */
               _.forEach(_navigation, nav => {
                   nav.url = `/sector/${page}/${nav.url}`;
               })
               //this.items = _navigation;
               this.cd.detectChanges();
           }
       });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewChecked(): void {

        if (!this.reCalcSubmenuPosition) {
            return;
        }

        this.reCalcSubmenuPosition = false;

        const itemElement = this.getCurrentItemElement();
        const submenuElement = this.getCurrentSubmenuElement();

        const submenuTop = submenuElement.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const paddingBottom = 20;

        submenuElement.style.maxHeight = `${viewportHeight - submenuTop - paddingBottom}px`;

        // calc megamenu position
        if (this.hoveredItem.menu.type !== 'megamenu') {
            return;
        }

        const container = submenuElement.offsetParent;
        const containerWidth = container.getBoundingClientRect().width;
        const megamenuWidth = submenuElement.getBoundingClientRect().width;

        if (this.direction.isRTL()) {
            const itemPosition = containerWidth - (itemElement.offsetLeft + itemElement.offsetWidth);
            const megamenuPosition = Math.round(Math.min(itemPosition, containerWidth - megamenuWidth));

            submenuElement.style.right = megamenuPosition + 'px';
        } else {
            const itemPosition = itemElement.offsetLeft;
            const megamenuPosition = Math.round(Math.min(itemPosition, containerWidth - megamenuWidth));

            submenuElement.style.left = megamenuPosition + 'px';
        }
    }

    getCurrentItemElement(): HTMLDivElement {
        if (!this.hoveredItem) {
            return null;
        }

        const index = this.items.indexOf(this.hoveredItem);
        const elements = this.itemElements.toArray();

        if (index === -1 || !elements[index]) {
            return null;
        }

        return elements[index].nativeElement as HTMLDivElement;
    }

    getCurrentSubmenuElement(): HTMLDivElement {
        if (!this.hoveredItem) {
            return null;
        }

        const index = this.items.filter(x => x.menu).indexOf(this.hoveredItem);
        const elements = this.submenuElements.toArray();

        if (index === -1 || !elements[index]) {
            return null;
        }

        return elements[index].nativeElement as HTMLDivElement;
    }
}
